$(document).ready(function() {
	if(!document.querySelector('.GPC0159')) return false;

	var c = {
		el: null,
		tab : null,
		template: null,
		init: function(){
			var _this = c;
			var els = document.querySelectorAll('.GPC0159');

			for (var i = 0; i < els.length; i++) {
				_this.el = els[i];
				_this.tab = _this.el.querySelector('.tabs-type-liner');
				_this.template = $(_this.el).find('.contents-template').clone();
				_this.pageTemplate = $(_this.el).find('#paginationTemplate').clone();
				$(_this.el).find('.contents-template').remove();
				$(_this.el).find('#paginationTemplate').remove();
				
				_this.addEvent();
				if(_this.tab) {
					if ($(_this.tab).find('a.active').length==0) {
						$(_this.tab).find('a').eq(0).trigger('click');
					} else {
						$(_this.tab).find('a.active').trigger('click');
					}
				}
			}
			// 20200406 START 이상현 - tab ui의 관계 정보 추가
			_this.addAriaRelationship(els);
			// 20200406 END
		},
		createProductItem: function(productList){
			var html = [];
			for (var i = 0; i < productList.length; i++) {
				var p = productList[i],
					template = $(c.template).clone().html();

				template = template.replace(/\*subject\*/g, p.subject)
								.replace(/\*urlPath\*/g, p.urlPath)
								.replace(/\*pageListbodycopy\*/g, p.pageListbodycopy)
								.replace(/\*date\*/g, (p.date==null || !p.date) ? '' : p.date)
								;

				var $template = $(template),
					$keyBlocks = $template.find('*[data-key]');

				for (var i1 = 0; i1 < $keyBlocks.length; i1++) {
					var $currentKeyBlock = $keyBlocks.eq(i1),
						key = $currentKeyBlock.get(0).getAttribute('data-key'),
						val = p[key];
					if(!val || (val == null || val == "N")) {
						if($currentKeyBlock.is('.btn')) {
							$currentKeyBlock.removeClass('active');
						}else {
							$currentKeyBlock.remove();
						}
					
					} /*else {
						if(key == "pageDisplayDateYn") {
							var itemDate = /\.|\/|-/.test(p.date) ? p.date.split(/\.|\/|-/) : p.date;
							if(itemDate instanceof Array) {
								var text = $currentKeyBlock.text();
								text = text.replace('yyyy', itemDate[0])
									.replace('mm', ('0' + itemDate[1]).slice(-2))
									.replace('dd', ('0' + itemDate[2]).slice(-2));
								$currentKeyBlock.text(text);
							}else {
								$currentKeyBlock.text(itemDate);
							}
						
						}
					}*/
				}

				if(!p.date || p.date == null) {
					$template.filter('.list').addClass('only-copy');
				}

				$template.find('template').remove();
				if(i == 0){ // accessiblity focus item
					$template.addClass('first-item');
				}
				template = $template.get(0).outerHTML;
				html += template;
			}

			return html;
		},
		// 20200406 START 이상현 - tab ui의 관계 정보 추가
		addAriaRelationship : function(tg){
			if($(tg).find('.js-tab').length > 0){
				$(tg).find('.js-tab').find('[role="tab"]').each(function(idx) {
					$(this).attr('id', 'tabLabel_' + (idx+1));
					$(tg).find('[role="tabpanel"]').eq(idx).attr('aria-labelledby', 'tabLabel_' + (idx+1));
				});
			}
		},
		// 20200406 END
		addEvent: function(){
			var _this = c;
			$(_this.el).on({
				submit: function(e, isTabEvent){
					e.preventDefault();
					var isExpander = $(e.delegateTarget).data('focus') == true;
					var url = e.currentTarget.action,
						param = xssfilter($(e.currentTarget).serialize());
					var $target = $(e.currentTarget).siblings('.list-contents-wrap');
					// check initialize
					var isInit = !$target.is('.initialized') && $target.closest('.tabs-cont').is(":first-child");
					// 20200506 START 이상현 - list 없을 시 화면 추가
					var $form = $(this);
					// 20200506 END
					ajax.noCacheCall(url, param, 'json', function(d){
						var data, html;
						if(d && d.data) data = d.data instanceof Array ? d.data[0] : d.data;

						// 20200506 START 이상현 - list 없을 시 화면 추가
						if(d.status == "success" && (data && data.contents && data.contents.length > 0) ) {
						// 20200506 END
							// making markup
							html = c.createProductItem(data.contents);

							// append markup
							var pageInfo = data.pageInfo;
							if(isExpander) {
								$target.find('.pagination').hide();
								$target.find('.unit-list').append(html);
								var pageVisible = pageInfo && pageInfo.view == "Y";
								if(pageVisible && pageInfo.page < pageInfo.pageCount) {
									$target.find('.expander button').get(0).value = pageInfo.page+1;
									$target.find('.expander').show();
								}else {
									$target.find('.expander').hide();
								}
							}else {
								$target.find('.expander').hide();
								$target.find('.unit-list').html(html);

								// setting pagination
								if(pageInfo && pageInfo.view == "Y") {
									if($target.find('.pagination').get(0)){
										var pageMarkup = [];
										for (var pageIdx = pageInfo.loopStart; pageIdx <= pageInfo.loopEnd; pageIdx++) {
											var _pageItem =  _this.pageTemplate.clone().html();
											_pageItem = $(_pageItem).get(0),
											_pageButton = _pageItem.querySelector('button');
											_pageButton.value = pageIdx;
											_pageButton.innerHTML = pageIdx;
											if(pageIdx.toString() == pageInfo.page) {
												_pageButton.setAttribute('class', 'active');
												// WA-GPC0038-03 : aria-current 추가
												_pageButton.setAttribute('aria-current', 'page');
											}
											if($target.find('.pagination').attr('data-aria-pattern')) {
												var _ariaText = $target.find('.pagination').attr('data-aria-pattern').replace(/\#/g, pageIdx);
												_pageButton.setAttribute('aria-label', _ariaText);
											}
											pageMarkup += _pageItem.outerHTML;
										}
										$target.find('.pagination ul').html(pageMarkup);

										$target.find('.pagination .prev').get(0).disabled = !pageInfo.leftPage;
										$target.find('.pagination .next').get(0).disabled = !pageInfo.rightPage;
										$target.find('.pagination .prev').get(0).value = pageInfo.page-1;
										$target.find('.pagination .next').get(0).value = pageInfo.page+1;
										$target.find('.pagination').show();
									}
								}else {
									$target.find('.pagination').hide();
								}

								if($target.hasClass('initialized')) {
									$('html, body').animate({
										scrollTop: $target.closest('.component').offset().top
									});
								}
							}

							if(!isTabEvent) {
								var $focusItem = $target.find(".first-item");
								$($focusItem).find("a").eq(0).focus();
								$($focusItem).removeClass("first-item");
							}

							$target.addClass('initialized');
						// 20200506 START 이상현 - list 없을 시 화면 추가
						}else {
							$target.closest(".component").find(".no-content-wrap").addClass("active");
							$form.trigger('ajaxLoadEnd');
						}
						// 20200506 END
					});
				}
			}, 'form');

			// tab click
			$(_this.tab).on({
				click: function(e){
					e.preventDefault();
					var target = $(e.currentTarget.getAttribute('href')).get(0),
						targetForm = target.querySelector('form');

					if(!$(target.querySelector('.list-contents-wrap')).is('.initialized')) {
						$(targetForm).trigger('submit', [true]);
					}
				}
			}, 'a');

			// page click
			$(_this.el).on({
				click: function(e){
					e.preventDefault();
					var page = e.currentTarget.value,
						targetForm = $(e.currentTarget).closest('.contents-area').find('form').get(0),
						_del = e.delegateTarget;

					targetForm.page.value = page;

					if($(e.currentTarget).closest('.expander')[0]) {
						$(_del).data('focus', true);
					}else {
						$(_del).data('focus', false);
						var pagePosition = "";
						if($(e.currentTarget).is(".prev")) {
							pagePosition = "L";
						}else if($(e.currentTarget).is(".next")){
							pagePosition = "R";
						}
						targetForm.pagePosition.value = pagePosition;
					}

					$(targetForm).trigger('submit', [false]);
				}
			}, '.pagination button, .expander button');
		}
	};

	c.init();
});